module.exports = __webpack_public_path__ + "img/wait_shipping.9924816a.svg";